import { ResponsiveSankey } from '@nivo/sankey'

const UtilizationSankeyChart = ({ sankeyData, height, classes = '' }) => {
  const { data, colors } = sankeyData
  const CustomLabel  = (node) => {
     const lines = node.node.split('\n')
     return (
         <g transform={`translate(${node.x}, ${node.y})`}>
             {lines.map((line, index) => (
                 <text
                     key={index}
                     x={0}
                     y={index * 20} // Adjust this value to control line spacing
                     style={{ fill: '#292424', fontSize: 16 }}
                 >
                     {line}
                 </text>
             ))}
         </g>
     );
   };

  return (
    <div className={classes} style={{ height: height }}>
        <ResponsiveSankey
            data={data}
            margin={{ top: 0, right: 190, bottom: 0, left: 230 }}
            align="justify"
            colors={colors}
            nodeOpacity={1}
            nodeThickness={35}
            nodeSpacing={32}
            nodeBorderWidth={0}
            nodeHoverOthersOpacity={0.35}
            linkOpacity={0.2}
            linkHoverOpacity={1}
            linkHoverOthersOpacity={0.1}
            linkContract={0.3}
            labelPosition="outside"
            labelPadding={16}
            labelTextColor="#292424"
            nodeBorderColor={{ from: 'color', modifiers: [['darker', 0.8]] }}
            enableLinkGradient
            theme={{
              fontName: 'ProximaNova',
              fontSize: 14
            }}
            nodeTooltip={(node) => {
              return (
                <div style={{ padding: '5px', backgroundColor: 'white', border: '1px solid black'}}>
                  <strong>
                      {node.node.id}
                  </strong>
                  <br />
                  <strong>
                  {node.node.amount}
                  </strong>
                  </div>
              );
          }}
          label={(node) =>{
            return (
              `${node.id}`
            );
          }}
           linkTooltip={(link) => {
            return (
              <div style={{ padding: '5px', backgroundColor: 'white', border: '1px solid black', display: 'flex', gap: '10px' }}>
                <div>
                  {link.link.source.id}<br />{link.link.source.amount}
                </div>
                ➔ 
                <div>
                  {link.link.target.id}<br />{link.link.target.amount}
                </div>
              </div> );
          }}
          // nodeComponent={CustomLabel}
        />
    </div>
);
}

export default UtilizationSankeyChart